import React from 'react';

import { InfoField } from '@occc-app/design-system';
import { AwardPointsFragment } from '@occc/graphql';

interface IPointsAwardProps {
  award: AwardPointsFragment;
}

export const PointsAward: React.FC<IPointsAwardProps> = ({ award }) => {
  return <InfoField label='Granted points' value={award?.points} />;
};
